// src/pages/RegulaminPage.jsx
export default function RegulaminPage() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h1>Regulamin sklepu Art Tolczyk</h1>

      <p>
        Sprzedawcą i administratorem sklepu internetowego jest:
        <br /><br />
        <b>Art Rafał Tołczyk</b><br />
        ul. Boya-Żeleńskiego 2<br />
        15-198 Białystok<br />
        NIP: 9661263250<br />
        E-mail: kontakt@arttolczyk.pl
      </p>

      <h2>§1. Informacje o produktach</h2>
      <p>
        Wszystkie obrazy dostępne w sklepie wykonywane są ręcznie.  
        Część dostępna jest od ręki, natomiast niektóre po zakupie
        wykonywane są na zamówienie – czas realizacji wynosi 10 dni roboczych.
      </p>

      <h2>§2. Zamówienia</h2>
      <p>
        Zamówienia można składać 24/7 poprzez stronę sklepu.  
        Po złożeniu zamówienia Klient otrzymuje potwierdzenie e-mail.
      </p>

      <h2>§3. Płatności</h2>
      <ul>
        <li>Przelewy24 / PayU (płatność online)</li>
        <li>Przelew tradycyjny – dane do przelewu wysyłane są e-mailem</li>
      </ul>

      <h2>§4. Dostawa</h2>
      <p>
        Darmowa wysyłka na terenie Polski.  
        Wysyłka zagraniczna – wycena indywidualna.
      </p>

      <h2>§5. Zwroty</h2>
      <p>
        Konsument ma 14 dni na odstąpienie od umowy.  
        Produkty wykonywane na zamówienie mogą nie podlegać zwrotowi.
      </p>

      <h2>§6. Reklamacje</h2>
      <p>Reklamacje należy kierować na adres: kontakt@arttolczyk.pl</p>

      <h2>§7. Postanowienia końcowe</h2>
      <p>W sprawach nieuregulowanych obowiązuje prawo polskie.</p>
    </section>
  );
}

